//Utility
import React from 'react';
import autoBind from 'react-autobind';
import ClassNames from 'classnames';
import _ from 'lodash';
import Screen from '../../utils/Screen.js';

//Actions
import PensionPaymentAction from '../../actions/PensionPaymentActions.js';
import ApplicationActions from '../../actions/ApplicationActions.js';

//Store
import PensionPaymentStore from '../../stores/PensionPaymentStore.js';

//Components
import SectionHeader from '../Common/SectionHeader.jsx';
import RadioInput from '../Common/RadioInput.jsx';
import TextInput from '../Common/TextInput.jsx';
import SpecifyBankAccountList from '../Common/SpecifyBankAccountList.jsx';
import BankAccountDetails from '../Common/BankAccountDetails.jsx';
import InlineMessage from '../Common/InlineMessage.jsx';
import SelectInput from '../Common/SelectInput.jsx';
import RadioButtonList from '../Common/RadioButtonList.jsx';
import Keyboard from '../../utils/Keyboard';

//Constants
import ApplicationConstants from '../../constants/ApplicationConstants';
import Constants from '../../constants/PensionPaymentConstants';

function getStateFromStores() {
    return {
        model: PensionPaymentStore.getPensionPaymentModel(),
        formError: PensionPaymentStore.getFormError(),
        pensionPaymentErrorList: PensionPaymentStore.pensionPaymentErrorMessages(),
        bankAccountsList: PensionPaymentStore.getBankAccountsList(),
        bankAccountDetailsMsg: PensionPaymentStore.getBankAccountDetailsMsg(),
        frequencyDatesData: PensionPaymentStore.getfrequencyDatesData(),
        paymentLevelsOption: PensionPaymentStore.getPaymentLevelsOption(),
        annualIncreaseOption: PensionPaymentStore.getAnnualIncreaseOption(),
        isPreRetirement: PensionPaymentStore.getIsPreRetirement(),
        isCustomOrderDisabled: PensionPaymentStore.getIsCustomOrderDisabled(),
        isInspecieYes: PensionPaymentStore.getIsInspecieYes()        
    };
}

export default class PensionPaymentSection extends React.Component {

    constructor(props) {
        super(props);
        autoBind(this);
        this.state = getStateFromStores();
    }

    componentDidMount() {
        PensionPaymentStore.addChangeListener(this._onChange);
    }

    componentWillUnmount() {
        PensionPaymentStore.removeChangeListener(this._onChange);
    }

    _onChange() {
        this.setState(getStateFromStores());
    }

    componentWillUpdate(nextProps, nextState) {
        if (this.state.model.drawDownOption !== nextState.model.drawDownOption) {
            ApplicationActions.sendPensionPaymentDrawDownOption(nextState.model.drawDownOption);
        }
    }

    updatePensionPaymentModel(e) {
        let fieldId = e.target.model,
            value = e.target.value,
            componentId = e.target.id;

        PensionPaymentAction.updatePensionPaymentModel(fieldId, value, componentId);
    }

    showDate() {
        return (this.state.model.accountStartDateOption === Constants.AccountStart.CUSTOM)
            ?   <section>
                    <TextInput id="pensPaymentaccountStartDate"
                        label="Pension commencement date"
                        value={this.state.model.accountStartDate}
                        placeholder={ApplicationConstants.DateFormat}
                        className="form-number-input"
                        onBlur={this.updatePensionPaymentModel}
                        model="accountStartDate"
                        contextualMessage={this.props.content.pensionPayment.dateSelectionText}
                        errorList={this.state.formError.errorList} 
                        maxLength={10}/>
                </section>
            : null;
    }

    showBankAccountsList() {
        return (this.state.bankAccountsList.length > 1)
            ?   <SpecifyBankAccountList id="pensPaymentbankAccountsList"
                    model="selectedBankAccount"
                    tableId="pensPaymentspecifyBankAccountTable"
                    data={this.state.bankAccountsList}
                    onChange={this.updatePensionPaymentModel}
                    checked={this.state.model.selectedBankAccount}
                    label="Where would you like your pension paid?" />
            : null;
    }

    showNominateOtherAccount() {
        let labelClass = ClassNames({ hidden: this.state.model.selectedBankAccount === Constants.nominateOtherAccount }, 'form-label-section');
        return (this.state.bankAccountsList.length === 1 || this.state.model.selectedBankAccount === Constants.nominateOtherAccount)
            ?   <div className="form-section">
                    <div className={labelClass}>
                        <label>Where would you like your pension paid?</label>
                    </div>
                    <BankAccountDetails id="pensPaymentbankNominateOtherAccount"
                        section="pensPayment"
                        data={this.state.model}
                        errorList={this.state.formError.errorList}
                        onBlur={this.updatePensionPaymentModel}
                    />
                </div>
            : null;
    }

    showBankAccountDetailsMsg() {
        return (this.state.bankAccountDetailsMsg)
            ?   <InlineMessage key="contextualMessageShowBankAccountDetailsMsg"
                    id="contextualMessageShowBankAccountDetailsMsg"
                    customClass="contextual-message-marginTopMed"
                    type={ApplicationConstants.messageTypes.info}
                    message={this.props.content.pensionPayment.provideBankDetailsHelpText}
                    isHidden={false} />
            : null;
    }

    showYearlyDateSelect() {
        return (this.state.model.paymentFrequency === Constants.PaymentFrequency.YEARLY)
            ?   <SelectInput id="pensPaymentyearlyFrequencyDate"
                    options={this.state.frequencyDatesData}
                    label="When would you like the payment to be made?"
                    value={this.state.model.yearlyFrequencyDate}
                    onChange={this.updatePensionPaymentModel}
                    searchable={false}
                    clearable={false}
                    disabled={false}
                    model="yearlyFrequencyDate"
                    errorList={this.state.formError.errorList} />
            : null;
    }

    showDeferPaymentsMessage() {
        if (!this.state.model.deferPaymentsText) {
            return null;
        }
        let deferPaymentsTextWithNoteHeader = '<h4>Please note</h4><p>' + this.state.model.deferPaymentsText + '</p>';
        return (<InlineMessage key="contextualMessageShowDeferPaymentsMessage"
                    id="contextualMessageShowDeferPaymentsMessage"
                    customClass="contextual-message-marginTopMed"
                    type={ApplicationConstants.messageTypes.info}
                    message={deferPaymentsTextWithNoteHeader}
                    isHidden={false} />);
    }

    showDeferPaymentsWithinFYearText() {
        if (!this.state.model.deferPaymentsWithinFYearText) {
            return null;
        }
        let deferPaymentsTextWithNoteHeader = '<h4>Please note</h4><p>' + this.state.model.deferPaymentsWithinFYearText + '</p>';
        return (<InlineMessage
                id="contextualMessageShowDeferPaymentsFinancialYear"
                customClass="contextual-message-marginTopLarge"
                type={ApplicationConstants.messageTypes.info}
                message={deferPaymentsTextWithNoteHeader}
                isHidden={false} />);
    }

    showPaymentGrossAmount() {
        let message = this.state.isPreRetirement? this.props.content.pensionPayment.grossAmountPreRetirement : this.props.content.pensionPayment.grossAmountNotPreRetirement;

        return this.state.model.paymentLevelsOption === Constants.PaymentLevels.SPECIFIC
        ?   <TextInput id="pensPaymentpaymentGrossAmount"
                label="What is the gross amount per pension payment?"
                model="paymentGrossAmount"
                symbol="currency"
                value={this.state.model.paymentGrossAmount}
                contextualMessage={message}
                onBlur={this.updatePensionPaymentModel}
                className="text-input-amount"
                errorList={this.state.formError.errorList} />
        : null;
    }

    showPaymentAnnualIncreaseOption() {
        return this.state.model.paymentLevelsOption === Constants.PaymentLevels.SPECIFIC
        ?   <RadioInput id="pensPaymentannualIncreaseOption"
                data={this.state.annualIncreaseOption}
                value={this.state.model.annualIncreaseOption}
                label="Would you like an annual increase?"
                onChange={this.updatePensionPaymentModel}
                model="annualIncreaseOption"
                errorList={this.state.formError.errorList} />
        : null;
    }

    showAnnualPercentage() {
        return this.state.model.paymentLevelsOption === Constants.PaymentLevels.SPECIFIC && this.state.model.annualIncreaseOption === Constants.AnnualIncrease.SET
        ?   <TextInput id="pensPaymentannualPercentage"
                label="Percentage"
                model="annualPercentage"
                symbol="percent"
                maxLength={2}
                value={this.state.model.annualPercentage}
                onBlur={this.updatePensionPaymentModel}
                className="text-input-amount"
                errorList={this.state.formError.errorList} />
        : null;
    }

    showProrataFirstPayment() {
        return this.state.model.paymentLevelsOption === Constants.PaymentLevels.SPECIFIC 
            ? <RadioInput id="proRataFirstdPayment"
                data={ApplicationConstants.YesNoRadioData}
                value={this.state.model.proRataFirstPayment}
                label="Would you like your first payment to be pro rata?"
                onChange={this.updatePensionPaymentModel}
                model="proRataFirstPayment"
                errorList={this.state.formError.errorList} 
                note="We may pro rata your first scheduled pension payment based on your account open date." />
            : null;
    }

    showIncreaseAndSetMessage() {
        let isErrorPresent = this.state.model.annualIncreaseOption === Constants.AnnualIncrease.SET && _.findIndex(this.state.formError.errorList, function(o) { return o.id === 'pensPaymentannualPercentage'; }) < 0? false : true;

        return this.state.model.paymentLevelsOption === Constants.PaymentLevels.SPECIFIC && this.state.model.annualIncreaseOption !== Constants.AnnualIncrease.NO_THANKS
        ?   <InlineMessage key="contextualMessageShowIncreaseAndSetMsg"
                id="contextualMessageShowIncreaseAndSetMsg"
                customClass="contextual-message-marginTopMed"
                type={ApplicationConstants.messageTypes.info}
                message={this.props.content.pensionPayment.annualPercentage}
                isHidden={isErrorPresent && this.state.model.annualIncreaseOption !== Constants.AnnualIncrease.INCREASE} />
        : null;
    }

    showDrawDownOptionType() {
        return this.state.model.investmentOptionList.length && this.state.model.drawDownOption === Constants.DrawDownOption.CUSTOM
        ?   <RadioInput id="pensPaymentdrawDownTypeOption"
                customClass="pens-payment-drawdown-type-option"
                data={Constants.DrawDownTypeOptionData}
                value={this.state.model.drawDownTypeOption}
                label="How would you like to draw down your payments?"
                onChange={this.updatePensionPaymentModel}
                model="drawDownTypeOption"
                errorList={this.state.formError.errorList} />
        : null;
    }

    setQtyFormat(qty) {
        return !isNaN(qty)? (Math.floor(100 * new Number(qty)) / 100).toFixed(2) : qty;
    }

    handleQtyOnBlur(e) {
        let qty = this.state.model.drawDownTypeOption === Constants.DrawDownTypeOption.PERCENTAGE? this.setQtyFormat(e.target.value) : e.target.value;
        PensionPaymentAction.updateInvestmentOption(e.target.id, qty);
    }

    keyValidate(e) {
        if (!Keyboard.isNumberKey(e)) {
            e.preventDefault(); 
        }
    }

    getInvestmentSymbol() {
        return this.state.model.drawDownTypeOption === Constants.DrawDownTypeOption.PERCENTAGE? 'percent' : 'none';
    }

    showTotalPercentage() {
        return this.state.model.drawDownTypeOption === Constants.DrawDownTypeOption.PERCENTAGE
        ?   <div className="table-percent">
                <span className="total">Total:</span>
                <strong>{this.state.model.totalAllocationPercentage}%</strong>
            </div>
        : null;
    }

    getInvestmentValue(data) {
        if (this.state.model.drawDownTypeOption === Constants.DrawDownTypeOption.PERCENTAGE) {
            return data.weight;
        } else {
            if (data.order === 0) {
                return data.order.toString();
            }
            return data.order;
        }
    }

    handleSameAsInvestAllocationOption(e) {
        var data = this.state.model.sameAsInvestAllocationOption === ApplicationConstants.YesNoValues.YES ? '' : e.target.value;
        PensionPaymentAction.setPensionAllocationSameAsInvestmentAllocation(data);
    }

    handleKeySelection(event) {
        if (event.keyCode === 32 || (event.keyCode >= 37 && event.keyCode <= 40)) {
            var value = document.getElementById(event.target.htmlFor).attributes.getNamedItem('value').value;
            this.handleSameAsInvestAllocationOption({ target: { value: value } });
            event.stopPropagation();
            event.preventDefault();
        }
    }

    handleMouseDown(event){
        event.preventDefault();
        event.stopPropagation();
    }

    showInvestmentAllocationTable() {
        let mapInvestmentOptionList = function (data, index) {
            var idx = Constants.pensPaymentInvOptPrefix + index.toString();
            return (
                <tr key={index}>
                    <td className="form-select table-vote">
                        <TextInput id={idx}
                            symbol={this.getInvestmentSymbol()}
                            value={this.getInvestmentValue(data)}
                            onKeyPress={this.keyValidate}
                            onBlur={this.handleQtyOnBlur}
                            maxLength={6}
                            className="pens-payment-investment-allocation-weight"
                            isDisabled={this.state.model.sameAsInvestAllocationOption === ApplicationConstants.YesNoValues.YES}
                            hasWarning={!data.isValid} />
                    </td>
                    <td className="form-select table-vote">{data.name}</td>
                    <td className="form-select table-vote">{data.code}</td>
                </tr>
            )
        };

        let investmentOptionListInlineError = function(data, index) {
            if(_.startsWith(data.id, Constants.pensPaymentInvOptPrefix)){
                return (<InlineMessage id={data.id} key={index} isHidden={false} type="error" message={data.message} />);
            }
        };

        let investmentAllocationTableText = { __html: this.props.content.pensionPayment.investmentAllocationTableText };

        let sameAsInvestAllocationCheckBox = this.state.model.drawDownTypeOption === Constants.DrawDownTypeOption.PERCENTAGE && !this.state.isInspecieYes
            ? <div className="form-select">
                        <label tabIndex="0" className={ClassNames({'btn-cfs': this.state.model.sameAsInvestAllocationOption === ApplicationConstants.YesNoValues.YES})} id="ripSameAsInvestAllocationlabel" htmlFor="ripSameAsInvestAllocation" onKeyDown={this.handleKeySelection} onMouseDown={this.handleMouseDown} tabIndex="0">
                            <i className="icon icon-check"></i>
                            <input id="ripSameAsInvestAllocation" type="radio" tabIndex="-1" className="btn-option btn btn-default btn-lg" onChange={this.handleSameAsInvestAllocationOption} value={ApplicationConstants.YesNoValues.YES} checked={this.state.model.sameAsInvestAllocationOption === ApplicationConstants.YesNoValues.YES} />
                        </label>
                    <label tabIndex="0" className="rip-inline-check-box">The same way as my selected initial investment allocation.</label>
               </div>
            : null;

        return this.state.model.investmentOptionList.length && this.state.model.drawDownTypeOption && this.state.model.drawDownOption === Constants.DrawDownOption.CUSTOM
        ?   <div id="pensPaymentinvestmentOptionList">
                {sameAsInvestAllocationCheckBox}
                <table className="table table-single pens-payment-investment-option-table">
                    <tbody>
                        {this.state.model.investmentOptionList.map(mapInvestmentOptionList, this)}
                    </tbody>
                </table>
                {this.showTotalPercentage()}
                <p className={ClassNames('pens-payment-investment-table-text', { percentage: this.state.model.drawDownTypeOption === Constants.DrawDownTypeOption.PERCENTAGE })} dangerouslySetInnerHTML={investmentAllocationTableText}></p>
                {this.state.formError.errorList.length? (this.state.formError.errorList).map(investmentOptionListInlineError) : null}
            </div>
        : null;
    }

    getDrawDownOptionData() {
        let data = Constants.DrawDownOptionData;
        let isDisabled = this.state.isCustomOrderDisabled;
        _.forEach(data,
            function(d) {
                if (d.id === Constants.DrawDownOption.CUSTOM) {
                    d['isDisabled'] = isDisabled ;
                }
            });
        return data;
    }

    showCustomOrderDisabledText() {
        return this.state.isCustomOrderDisabled
        ? <div className="special-requirement-link-message">Custom ordering is not available because we don't have your investment option information at hand. To select custom ordering provide your instructions in the <a onClick={this.switchToSpecialRequirementSection}>special request section</a> at the end of the form.</div>
        : null;
    }

    switchToSpecialRequirementSection() {
        Screen.moveToNextSection('specialRequestsSection');
    }

render() {

        return (

            <div className="form-step">
                <SectionHeader focus={this.props.focus} sectionName="Pension establishment and payment details" sectionHelpText={this.props.content.common.sectionHeaderHelp} NeedHelpInfo={this.props.content.pensionPayment.pensionPaymentHelp} />
                <div className="container">
                    <RadioInput id="pensPaymentaccountStartDateOption"
                        customClass="pens-payment-account-startdate-option"
                        data={Constants.AccountStartData}
                        value={this.state.model.accountStartDateOption}
                        label="Once all monies are received when would you like your pension account to commence?"
                        helpText={this.props.content.pensionPayment.accountStartHelp}
                        onChange={this.updatePensionPaymentModel}
                        model="accountStartDateOption"
                        errorList={this.state.formError.errorList} />

                    {this.showDate()}
                    {this.showBankAccountsList()}
                    {this.showNominateOtherAccount()}
                    {this.showBankAccountDetailsMsg()}                    

                    <RadioButtonList data={Constants.PaymentFrequencyData}
                        customClass="pens-payment-frequency-data"
                        handleChange={this.updatePensionPaymentModel}
                        label="How often would you like to receive your pension payments?"
                        id="pensPayment"
                        model="paymentFrequency"
                        value={this.state.model.paymentFrequency} />

                    <div className="form-section">
                        {this.showYearlyDateSelect()}
                        {this.showDeferPaymentsMessage()}

                        <RadioInput id="pensPaymentdeferPayments"
                            data={ApplicationConstants.YesNoRadioData}
                            value={this.state.model.deferPayments}
                            label="For accounts that commence in June, would you like to defer your payments until next financial year?"
                            onChange={this.updatePensionPaymentModel}
                            model="deferPayments"
                            errorList={this.state.formError.errorList} />

                        {this.showDeferPaymentsWithinFYearText()}

                        <RadioInput id="firstPaymentDuringCoolingOff"
                            data={ApplicationConstants.YesNoRadioData}
                            value={this.state.model.firstPaymentDuringCoolingOff}
                            label="Would you like to receive your first pension payment during the 14 day cooling-off period?"
                            onChange={this.updatePensionPaymentModel}
                            model="firstPaymentDuringCoolingOff"
                            errorList={this.state.formError.errorList}
                            note="By exercising this right, your cooling-off period will end once your first pension payment is made."/>

                    </div>

                    <RadioInput id="pensPaymentpaymentLevelsOption"
                        data={this.state.paymentLevelsOption}
                        value={this.state.model.paymentLevelsOption}
                        label="How much would you like to receive per payment?"
                        onChange={this.updatePensionPaymentModel}
                        model="paymentLevelsOption"
                        errorList={this.state.formError.errorList} />
                    
                    {this.showPaymentGrossAmount()}
                    {this.showPaymentAnnualIncreaseOption()}
                    {this.showAnnualPercentage()}
                    {this.showIncreaseAndSetMessage()}
                    {this.showProrataFirstPayment()}

                    <RadioInput id="pensPaymentdrawDownOption"
                        data={this.getDrawDownOptionData()}
                        value={this.state.model.drawDownOption}
                        label="How would you like to draw down your payments from your investment options?"
                        onChange={this.updatePensionPaymentModel}
                        model="drawDownOption"
                        customClass={this.state.isCustomOrderDisabled ? 'radio-button-list-has-description' : null}
                        errorList={this.state.formError.errorList} />
                    {this.showCustomOrderDisabledText()}
                    {this.showDrawDownOptionType()}
                    {this.showInvestmentAllocationTable()}
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/PensionPayment/PensionPaymentSection.jsx